export default "__VITE_ASSET__Cj4Ql1wO__"